import React from "react";

export default function Footer() {
  return (
    <div className="main-footer">
      <span></span>
      {/* <span>Created by: <Link to="http://themepixels.me" target="_blank"></Link></span> */}

      <span>&copy; {new Date().getFullYear()} Deda Hospital. All rights reserved.</span>
    </div>
  )
}
